import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalSkipButtonAds.scss';
import { cls, Button } from '../../packages/components';
import { withRouter } from 'react-router';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import Translator from '../../requests/apa/Translator';

const ModalSkipButtonAds = () => {
    const modalProps = {
      classNameComponent: `wrapper_skip-button-ads`,
      className: `container_skip-button-ads`
    };

    const textButton = Translator.get('Player_Boton_TextoTitulo', "");

    window.SpatialNavigation.focus();

    return (
        <ModalWrapper {...modalProps}>
            <Button
                activate
                type="button"
                variant="primary"
                className={cls(
                    `focusable`,
                    `skip-button-ads`,
                )}
                onClick={async () => {
                    await AAFPlayer.skipAds();
                }}
            >
                {textButton}
            </Button>
        </ModalWrapper>
    );
};

export default withRouter(withOnClose(ModalSkipButtonAds));



// WEBPACK FOOTER //
// ./src/components/Modal/ModalSkipButtonAds.jsx